import React from "react";
import { isPositiveStatus } from "../../utils";
import { StatusItem } from "./types";
import StatusPill from "./StatusPill";
import styles from "./systemHealth.module.css";

type SqsQueueTableProps = {
  queues: (StatusItem & { key: string })[];
};

const SqsQueueTable: React.FC<SqsQueueTableProps> = ({ queues }) => {
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.dataTable}>
        <thead>
          <tr>
            <th>Queue</th>
            <th>Status</th>
            <th>Latency</th>
          </tr>
        </thead>
        <tbody>
          {queues.map((queue) => (
            <tr
              key={queue.key}
              className={
                !isPositiveStatus(queue.status) ? styles.rowUnhealthy : ""
              }
            >
              <td className={styles.tableNameCell}>
                {queue.ui_display_name || queue.key}
              </td>
              <td>
                <StatusPill status={queue.status} />
              </td>
              <td>{queue.latency_ms != null ? `${queue.latency_ms} ms` : "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SqsQueueTable;
